import styled, { css } from 'styled-components'

export const StyledIcon = styled.svg`
  fill: ${(props) => props.color}
    ${(props) =>
      props.opacity &&
      css`
        opacity: ${props.opacity};
      `};
`
